import { Typography, Grid, IconButton } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { useCodelist } from "../../hooks/useCodelist";
import { codelistUtils } from "../../utils/codelistUtils";
import Loader from "../common/Loader/Loader";
import { hideLoader, showLoader } from "../../store/slices/loaderSlice";
import { useAppDispatch } from "../../store";

const StudyDetails: React.FunctionComponent<any> = (props) => {
  const dispatch = useAppDispatch();
  const { studyDetails, onEditStudyClick } = props;

  const [codeListDataObject, setCodeListDataObject] = useState<any>({});

  const codes = ["STUDY_TYPE", "STUDY_PHASE"];

  const { getCodelistData, codelistData, codelistIsLoading } = useCodelist();

  useEffect(() => {
    getCodelistData({ data: { code_list_codes: codes } });
  }, []);

  useEffect(() => {
    if (codelistIsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [codelistIsLoading]);

  useEffect(() => {
    if (codelistData) {
      setCodeListDataObject(codelistData);
    }
  }, [codelistData]);

  return (
    <>
      <Loader />
      <Typography variant="h5" component="div" className="mt1 mb3">
        Study Overview
        <IconButton
          color="primary"
          title="Edit Study details"
          onClick={onEditStudyClick}
          aria-label="Click to edit study details"
        >
          <EditIcon />
        </IconButton>
      </Typography>
      {studyDetails && studyDetails?.study_details && (
        <Grid container spacing={3} className="pageContent">
          <Grid item md={9} sm={9} xs={12}>
            <Typography variant="caption" display="block">
              Study Title
            </Typography>
            <Typography variant="body1" gutterBottom className="wordWrap">
              {studyDetails?.study_details?.title}
            </Typography>

            <Typography variant="caption" display="block">
              Brief Summary
            </Typography>
            <Typography
              variant="body1"
              gutterBottom
              className="wordWrap whiteSpacePre"
            >
              {studyDetails?.study_details?.brief_summary}
            </Typography>

            <Typography variant="caption" display="block">
              Primary Disease or Conditions
            </Typography>
            <ul className="listwithNoMP fw500 wordBreakAll">
              {studyDetails?.primary_disease_or_conditions?.map(
                (item: string, index: number) => (
                  <li key={`${item}-${index}`}>{item}</li>
                )
              )}
            </ul>

            <Typography
              variant="caption"
              display="block"
              className="mt3"
              gutterBottom
            >
              Treatment
            </Typography>
            <ul className="listwithNoMP fw500 wordBreakAll">
              {studyDetails?.treatments?.map((item: string, index: number) => (
                <li key={`${item}-${index}`}>{item}</li>
              ))}
            </ul>
          </Grid>
          <Grid item md={3} sm={3}>
            <Typography variant="caption" display="block">
              Study Type
            </Typography>
            <Typography variant="body1" gutterBottom>
              {codeListDataObject &&
                codeListDataObject.length > 0 &&
                codelistUtils(
                  codeListDataObject,
                  "STUDY_TYPE"
                )?.codelistCodeValues?.find(
                  (e: any) =>
                    e.code_list_value_code ==
                    studyDetails?.study_details?.study_type_value_code
                )?.code_list_value}
            </Typography>

            <Typography variant="caption" display="block">
              Phase
            </Typography>
            <Typography variant="body1" gutterBottom>
              {codeListDataObject &&
                codeListDataObject.length > 0 &&
                codelistUtils(
                  codeListDataObject,
                  "STUDY_PHASE"
                )?.codelistCodeValues?.find(
                  (e: any) =>
                    e.code_list_value_code ==
                    studyDetails?.study_details?.study_phase_value_code
                )?.code_list_value}
            </Typography>

            <Typography variant="caption" display="block">
              Study Start (Actual)
            </Typography>
            <Typography variant="body1" gutterBottom>
              {studyDetails?.study_details?.start_date &&
                dayjs(studyDetails?.study_details?.start_date).format(
                  "MM-DD-YYYY"
                )}
            </Typography>

            <Typography variant="caption" display="block">
              Primary Completion (Estimated)
            </Typography>
            <Typography variant="body1" gutterBottom>
              {studyDetails?.study_details?.primary_completion_date &&
                dayjs(
                  studyDetails?.study_details?.primary_completion_date
                ).format("MM-DD-YYYY")}
            </Typography>

            <Typography variant="caption" display="block">
              Study Completion (Estimated)
            </Typography>
            <Typography variant="body1" gutterBottom>
              {studyDetails?.study_details?.study_completion_date &&
                dayjs(
                  studyDetails?.study_details?.study_completion_date
                ).format("MM-DD-YYYY")}
            </Typography>

            <Typography variant="caption" display="block">
              Enrollment (Estimated)
            </Typography>
            <Typography variant="body1" gutterBottom>
              {studyDetails?.study_details?.enrollment}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default StudyDetails;
